export function BracketsIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M12.3805 13.3334C13.2218 13.3334 13.9045 12.6514 13.9045 11.8094V8.76208L14.6665 8.00008L13.9045 7.23808V4.19075C13.9045 3.34875 13.2225 2.66675 12.3805 2.66675'
        fill='white'
      />
      <path
        d='M3.61931 2.66675C2.77731 2.66675 2.09531 3.34875 2.09531 4.19075V7.23808L1.33331 8.00008L2.09531 8.76208V11.8094C2.09531 12.6514 2.77731 13.3334 3.61931 13.3334'
        fill='white'
      />
      <path
        d='M5.33331 8.00008C5.33331 8.18418 5.18407 8.33341 4.99998 8.33341C4.81588 8.33341 4.66665 8.18418 4.66665 8.00008C4.66665 7.81599 4.81588 7.66675 4.99998 7.66675C5.18407 7.66675 5.33331 7.81599 5.33331 8.00008Z'
        fill='white'
      />
      <path
        d='M8.33331 8.00008C8.33331 8.18418 8.18407 8.33341 7.99998 8.33341C7.81589 8.33341 7.66665 8.18418 7.66665 8.00008C7.66665 7.81599 7.81589 7.66675 7.99998 7.66675C8.18407 7.66675 8.33331 7.81599 8.33331 8.00008Z'
        fill='white'
      />
      <path
        d='M11.3333 8.00008C11.3333 8.18418 11.1841 8.33341 11 8.33341C10.8159 8.33341 10.6666 8.18418 10.6666 8.00008C10.6666 7.81599 10.8159 7.66675 11 7.66675C11.1841 7.66675 11.3333 7.81599 11.3333 8.00008Z'
        fill='white'
      />
      <path
        d='M12.3805 13.3334C13.2218 13.3334 13.9045 12.6514 13.9045 11.8094V8.76208L14.6665 8.00008L13.9045 7.23808V4.19075C13.9045 3.34875 13.2225 2.66675 12.3805 2.66675M3.61931 2.66675C2.77731 2.66675 2.09531 3.34875 2.09531 4.19075V7.23808L1.33331 8.00008L2.09531 8.76208V11.8094C2.09531 12.6514 2.77731 13.3334 3.61931 13.3334M4.99998 8.00008H5.00665M7.99998 8.00008H8.00665M11 8.00008H11.0066M5.33331 8.00008C5.33331 8.18418 5.18407 8.33341 4.99998 8.33341C4.81588 8.33341 4.66665 8.18418 4.66665 8.00008C4.66665 7.81599 4.81588 7.66675 4.99998 7.66675C5.18407 7.66675 5.33331 7.81599 5.33331 8.00008ZM8.33331 8.00008C8.33331 8.18418 8.18407 8.33341 7.99998 8.33341C7.81588 8.33341 7.66665 8.18418 7.66665 8.00008C7.66665 7.81599 7.81588 7.66675 7.99998 7.66675C8.18407 7.66675 8.33331 7.81599 8.33331 8.00008ZM11.3333 8.00008C11.3333 8.18418 11.1841 8.33341 11 8.33341C10.8159 8.33341 10.6666 8.18418 10.6666 8.00008C10.6666 7.81599 10.8159 7.66675 11 7.66675C11.1841 7.66675 11.3333 7.81599 11.3333 8.00008Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
